import Modal from "@material-ui/core/Modal";
import { ButtonStyled } from "components/buttons/buttons.styled";
import { Text } from "components/Typography/text.styled";
import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import { CompanyCalendarGigDto, Filter } from "model/Calendar";
import React from "react";
import { useTranslation } from "react-i18next";
import { NotFilledGigModalBody } from "./weeklyCalendar.styled";

type NotFilledGigModalProps = {
  showNotFilledModal: boolean;
  setShowNotFilledModal: React.Dispatch<React.SetStateAction<boolean>>;
  deleteShift: (shiftId: number, gigId: string) => void;
  shiftData: CompanyCalendarGigDto;
  clickedShiftId?: number;
  filter: Filter[];
};

export const NotFilledGigModal: React.FC<NotFilledGigModalProps> = ({
  showNotFilledModal,
  setShowNotFilledModal,
  deleteShift,
  shiftData,
  clickedShiftId,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Modal
        open={showNotFilledModal}
        onClose={() => {
          setShowNotFilledModal(false);
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <NotFilledGigModalBody>
          <Text
            fontFamily={FontFamily.MontserratSemiBold}
            color={Color.PitchBlack}
            fontSize={FontSize.H3}
          >
            {t("CalendarCompany.NotFilled")}
          </Text>
          <Text
            fontFamily={FontFamily.MontserratRegular}
            color={Color.PitchBlack}
          >
            {t("CalendarCompany.ThisGigHasNotBeenFilled")}
          </Text>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: "40px",
            }}
          >
            <ButtonStyled
              backgroundColor={Color.LighterDestructive}
              isCancel
              onClick={() => {
                if (shiftData && clickedShiftId) {
                  deleteShift(clickedShiftId, shiftData.id.toString());
                }
                setShowNotFilledModal(false);
              }}
            >
              {t("CompanyTimeReport.DeleteShift")}
            </ButtonStyled>
          </div>
        </NotFilledGigModalBody>
      </Modal>
    </>
  );
};
